import ResetPasswordWindow from './ResetPasswordWindow';

export default ResetPasswordWindow;